"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var SuppliedProduct_1 = require("../model/SuppliedProduct");

var SuppliedProductConverter_1 = require("./SuppliedProductConverter");
/**
 *
 * Implementation of {@link SuppliedProductConverter}.
 * @author Radek Beran
 */


var SuppliedProductConverterImpl =
/*#__PURE__*/
function (_SuppliedProductConve) {
  _inherits(SuppliedProductConverterImpl, _SuppliedProductConve);

  function SuppliedProductConverterImpl() {
    _classCallCheck(this, SuppliedProductConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SuppliedProductConverterImpl).apply(this, arguments));
  }

  _createClass(SuppliedProductConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SuppliedProduct_1.SuppliedProduct(SuppliedProduct_1.SuppliedProduct.schema.id.valueOf(conversions.documentToClassId(source)), SuppliedProduct_1.SuppliedProduct.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), SuppliedProduct_1.SuppliedProduct.schema.productName.valueOfField(source), SuppliedProduct_1.SuppliedProduct.schema.productExternalId.valueOfField(source), utils_1.Utils.isValueMissing(source.supplierId) ? null : SuppliedProduct_1.SuppliedProduct.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), utils_1.Utils.isValueMissing(source.supplierName) ? null : SuppliedProduct_1.SuppliedProduct.schema.supplierName.valueOfField(source), utils_1.Utils.isValueMissing(source.cmCategoryId) ? utils_1.Utils.VOID_ID : SuppliedProduct_1.SuppliedProduct.schema.cmCategoryId.valueOf(conversions.toClassReferenceId(source.cmCategoryId)), SuppliedProduct_1.SuppliedProduct.schema.categoryPlanId.valueOf(conversions.toClassReferenceId(source.categoryPlanId)), SuppliedProduct_1.SuppliedProduct.schema.categoryPlanName.valueOfField(source), SuppliedProduct_1.SuppliedProduct.schema.category4BOXName.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        productName: source.productName,
        productExternalId: source.productExternalId,
        supplierId: source.supplierId !== null ? conversions.toDocumentReferenceId(source.supplierId) : null,
        supplierName: source.supplierName,
        cmCategoryId: conversions.toDocumentReferenceId(source.cmCategoryId),
        categoryPlanId: conversions.toDocumentReferenceId(source.categoryPlanId),
        categoryPlanName: source.categoryPlanName,
        category4BOXName: source.category4BOXName
      });
      return result;
    }
  }]);

  return SuppliedProductConverterImpl;
}(SuppliedProductConverter_1.SuppliedProductConverter);

exports.SuppliedProductConverterImpl = SuppliedProductConverterImpl;